export const LANGUAGE_KEY = {
  // 角色选择
  LAST_RECHARGE: 'qc_sdk_last_recharge',
  LAST_LOGIN: 'qc_sdk_last_login',
  CURRENT_ROLE: 'qc_sdk_current_role',
  CONFIRM: 'qc_sdk_confirm',
  
  // 登录相关
  TITLE_ACCOUNT_LOGIN: 'qc_sdk_title_account_login',
  EMAIL_INPUT_PLACEHOLDER: 'qc_sdk_email_input_placeholder',
  PASSWORD_INPUT_PLACEHOLDER: 'qc_sdk_password_input_placeholder',
  VERIFICATION_CODE_INPUT_PLACEHOLDER: 'qc_sdk_verification_code_input_placeholder',
  DESC_LOGIN_BTN: 'qc_sdk_desc_login_btn',
  DESC_OTHER_LOGIN_METHOD: 'qc_sdk_desc_other_login_method',
  DESC_RECOVER_PASSWORD: 'qc_sdk_desc_recover_password',
  TITLE_RECOVER_PASSWORD: 'qc_sdk_title_recover_password',
  DESC_SEND: 'qc_sdk_desc_send',
  DESC_RESEND: 'qc_sdk_desc_resend',
  TOKEN_EXPIRED_PROMPT: 'qc_sdk_token_expired_prompt',
  
  // 提示信息
  PROMPT_INPUT_EMAIL: 'qc_sdk_prompt_input_email',
  PROMPT_INPUT_CORRECT_EMAIL: 'qc_sdk_prompt_input_correct_email',
  PROMPT_INPUT_PASSWORD: 'qc_sdk_prompt_input_password',
  PROMPT_INPUT_CORRECT_PASSWORD: 'qc_sdk_prompt_input_correct_password',
  PROMPT_INPUT_VERIFICATION_CODE: 'qc_sdk_prompt_input_verification_code',
  PROMPT_INPUT_CORRECT_VERIFICATION_CODE: 'qc_sdk_prompt_input_correct_verification_code',
  PROMPT_TOAST_SEND_SUCCESS: 'qc_sdk_prompt_toast_send_success',
  PROMPT_TOAST_EDIT_SUCCESS: 'qc_sdk_prompt_toast_edit_success',
  
  // 支付相关
  SELECT_PAYMENT_METHOD: 'qc_sdk_select_payment_method',
  PAYMENT_BTN: 'qc_sdk_payment_btn',
  PAYMENT_ALIPAY: 'qc_sdk_payment_alipay',
  PAYMENT_WECHAT: 'qc_sdk_payment_wechat',
  PAYMENT_HUABEI: 'qc_sdk_payment_huabei',
  PAYMENT_ALIPAY_QRCODE: 'qc_sdk_payment_alipay_qrcode',
  PAYMENT_WECHAT_QRCODE: 'qc_sdk_payment_wechat_qrcode',
  PAYMENT_APPLE: 'qc_sdk_payment_apple',
  PAYMENT_APPLE_STOREKIT2: 'qc_sdk_payment_apple_storekit2',
  PAYMENT_ONE_STORE: 'qc_sdk_payment_one_store',
  PAYMENT_HUAWEI_OVERSEAS: 'qc_sdk_payment_huawei_overseas',
  PAYMENT_SANSUNG: 'qc_sdk_payment_sansung',
  PAYMENT_AMAZON: 'qc_sdk_payment_amazon',
  PAYMENT_AIRWALLEX: 'qc_sdk_payment_airwallex',
  PAYMENT_THAILAND: 'qc_sdk_payment_thailand',
  PAYMENT_EUROPE_AMERICA: 'qc_sdk_payment_europe_america',
  PAYMENT_TAIWAN: 'qc_sdk_payment_taiwan',
  PAYMENT_SOUTHEAST_ASIA: 'qc_sdk_payment_southeast_asia',
  PAYMENT_VIETANM: 'qc_sdk_payment_vietanm',
  PAYMENT_PAY_PAY: 'qc_sdk_payment_pay_pay',
  PAYMENT_PAY_PAL: 'qc_sdk_payment_pay_pal',
  PAYMENT_PAY_LETTER: 'qc_sdk_payment_pay_letter',
  PAYMENT_WECHAT_JSSDK: 'qc_sdk_payment_wechat_jssdk',
  PAYMENT_WECHAT_H5: 'qc_sdk_payment_wechat_h5',
  PAYMENT_ALIPAY_MOBILE_WEB: 'qc_sdk_payment_alipay_mobile_web',
  PAYMENT_ALIPAY_PC_WEB: 'qc_sdk_payment_alipay_pc_web',
  PAYMENT_ALIPAY_INTERNATIONAL_CARD: 'qc_sdk_payment_alipay_international_card',
  PAYMENT_ALIPAY_INTERNATIONAL_GOOGLE: 'qc_sdk_payment_alipay_international_google',
  PAYMENT_ALIPAY_INTERNATIONAL_PAYPAL: 'qc_sdk_payment_alipay_international_paypal',
  PAYMENT_ALIPAY_INTERNATIONAL_APPLE: 'qc_sdk_payment_alipay_international_apple',
  PAYMENT_XSOLLA_PAYPAL: 'qc_sdk_payment_xsolla_paypal',
  PAYMENT_ALIPAY_INTERNATIONAL: 'qc_sdk_payment_alipay_international',
  PAYMENT_PAYERMAX_CARD: 'qc_sdk_payment_payermax_card',
  PAYMENT_PAYERMAX_GOOGLE: 'qc_sdk_payment_payermax_google',
  PAYMENT_PAYERMAX_APPLE: 'qc_sdk_payment_payermax_apple',
  PAYMENT_ENJOYPAY_CARD: 'qc_sdk_payment_enjoypay_card',
  PAYMENT_ENJOYPAY_APPLE: 'qc_sdk_payment_enjoypay_apple',
  PAYMENT_ENJOYPAY_GOOGLE: 'qc_sdk_payment_enjoypay_google',
  PAYMENT_ENJOYPAY_PAYPAY: 'qc_sdk_payment_enjoypay_paypay',
};